import React, { useEffect, useState } from "react";
import { Add } from "../../assets";
import { MdDelete } from "react-icons/md";
import { CiCirclePlus } from "react-icons/ci";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../../constance";
import Multiselect from 'multiselect-react-dropdown';



function AddQuestion() {
  const { id } = useParams();
  const [question, setQuestion] = useState("");
  const [type, setType] = useState("single");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [objects, setObjects] = useState([]);
  const [product, setProduct] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleErase = () => {
    setQuestion("");
    setType("");
    setObjects([]);
    setProduct([]);
    setSelectedOptions({})
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(`/mcqs/admin/` + id)
        .then((res) => {
          setQuestion(res?.data?.question);
          setType(res?.data?.type);
          setObjects(res?.data?.options);
          setLoading(false);
        })
        .catch((error) => {
          console.error("There was an error adding the product:", error);
          setLoading(false);
        });
    }
  }, [id]);


  const addObject = () => {
    const newObject = {
      text: "",
      productIds: [],
    };
    setObjects([...objects, newObject]);
  };

  const deleteObject = (index) => {
    setObjects(objects.filter((obj, i) => i !== index));
  };

  const updateOption = (index, newOption) => {
    setObjects(
      objects.map((obj, i) => (i === index ? { ...obj, text: newOption } : obj))
    );
  };

  const updateSelect = (index, selected) => {
    setSelectedOptions((prev) => ({ ...prev, [index]: selected }));
    setObjects(
      objects.map((obj, i) =>
        i === index ? { ...obj, productIds: selected.map((option) => option.value) } : obj
      )
    );
  };

  const validate = () => {
    let errors = {};
    if (!question || question.trim() === "") {
      errors.question = "Question is required";
    }

    return errors;
  };

  useEffect(() => {
    axios
      .get("/products")
      .then((response) => {
        const productOptions = response.data.map((product) => ({
          value: product._id,
          label: product.title,
        }));
        setProduct(productOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (id && product.length > 0) {
      axios
        .get(`/mcqs/admin/${id}`)
        .then((res) => {
          const selectedValues = res.data.options.map((option, index) => {
            return option.productIds.map((productId) => {
              return product.find((prod) => prod.value === productId);
            });
          });
          setSelectedOptions((prev) => {
            const newObj = {};
            selectedValues.forEach((val, index) => {
              newObj[index] = val;
            });
            return newObj;
          });
        })
        .catch((error) => {
          console.error("There was an error:", error);
        });
    }
  }, [id, product]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      const mcqdata = {
        question,
        type: type,
        options: objects,
      };
      if (id) {
        setLoading(true);
        axios
          .put(`/mcqs/${id}`, mcqdata)
          .then((res) => {
            setLoading(false);
            navigate("/admin/question");
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        setLoading(true);
        axios
          .post(`/mcqs`, mcqdata)
          .then((res) => {
            navigate("/admin/question");
            setLoading(false);
          })
          .catch((error) => {
            console.error("There was an error adding the product:", error);
            setLoading(false);
          });
      }
    } else {
      setErrors(errors);
    }
  };

  return (
    <div className="container mx-auto mt-36 min-h-screen">
      {loading && <Loader loading={loading} />}
      <div className="flex  mt-10">
        <h2 className="text-primary text-[25px] font-semibold">
          Add Questions
        </h2>
      </div>
      <div className="md:flex  flex-row gap-10 mb-10 items-center mt-10">
        <button
          className={`px-12 py-2 rounded-md md:mt-0 w-full md:w-auto ${type === "single" ? "bg-primary text-white" : "bg-white  border-2"
            }`}
          onClick={() => setType("single")}
        >
          Single Question
        </button>
        <button
          className={`md:px-12 py-2 rounded-md mt-5 md:mt-0 w-full md:w-auto ${type === "multiple" ? "bg-primary text-white" : "bg-white border-2"
            }`}
          onClick={() => setType("multiple")}
        >
          Multi Question
        </button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="text-[16px] leading-[25px] mb-10">
          <input
            type="text"
            value={question}
            onChange={(e) => {
              setQuestion(e.target.value);
            }}
            placeholder="Enter Your Question"
            className="w-full mt-5 border  border-primary py-1.5 rounded-md px-6 mb-1"
          />
          {errors.question && (
            <div style={{ color: "red" }}>{errors.question}</div>
          )}
        </div>

        {objects.map((obj, index) => {
          const errors = validate(obj);
          return (
            <div
              key={index}
              className="md:flex flex-row justify-between items-center relative md:max-w-[80vw] md:border-none border-b border-b-primary md:pb-0 pb-2 my-5"
            >
              <input
                type="text"
                value={obj.text}
                onChange={(e) => updateOption(index, e.target.value)}
                placeholder="Enter option"
                required
                className="py-2 px-6 w-full mb-2 md:mb-0 placeholder:Option  border rounded-md md:w-[35vw] text-sm"
              />

              <div className="flex flex-row justify-center items-center">
                <Multiselect
                  options={product}
                  selectedValues={selectedOptions[index]}
                  onSelect={(selectedList, selectedItem) => updateSelect(index, selectedList)}
                  onRemove={(selectedList, removedItem) => updateSelect(index, selectedList)}
                  displayValue="label"
                  className="py-2.5 px-6 placeholder:Option  md:w-[35vw] rounded-md  w-full text-sm"
                  placeholder="Select Options"
                />
                <button
                  className="delete-icon md:py-2 md:px-4 -pl-2 "
                  onClick={() => deleteObject(index)}
                >
                  <MdDelete className="text-2xl text-red-500  " />
                </button>
              </div>
            </div>
          );
        })}
        <button
          type="text"
          className="py-2 px-6 mb-10 rounded-full flex flex-row justify-start items-center gap-2 bg-primary text-white font-semibold"
          onClick={addObject}
        >
          Add Options
          <CiCirclePlus className="text-2xl " />
        </button>
        <div className="flex flex-row md:gap-10 justify-between md:justify-normal mb-10 items-center mt-10  ">
          <button
            type="submit"
            className={`md:px-12 px-6 py-2 rounded-md bg-primary text-white`}
          >
            {id ? "Update" : "Add"}
          </button>
          <button
            // onClick={!id ? handleErase : ''}
            className={`md:px-12 px-6 py-1.5 rounded-md bg-white border border-primary text-black`}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddQuestion;
